import React from 'react'
import { Row } from '@navent-jobs/ui-kit/components/grid'
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import Text from '@navent-jobs/ui-kit/components/text'
import { MotiveContainer, InfoText, TitleContainer } from './mixins'

interface OpcionClickeable {
  title: string
  iconObject: {
    name: string
    color: string
    size: string
  }
  texts: string[]
  onClick: () => void
}

const Component = ({ title, iconObject, texts, onClick }: OpcionClickeable) => {
  return (
    <MotiveContainer onClick={onClick}>
      <Row noGutter>
        <TitleContainer hasTexts={texts && texts.length > 0}>
          <Text size="md" fontWeight="semibold">
            {title}
          </Text>
          <Icon name={iconObject.name} color={iconObject.color} size={iconObject.size} />
        </TitleContainer>
      </Row>
      {texts &&
        texts.length > 0 &&
        texts.map((t, index) => {
          return (
            <InfoText key={index}>
              <Text size="sm">{t}</Text>
            </InfoText>
          )
        })}
    </MotiveContainer>
  )
}

export default Component
